import { render, staticRenderFns } from "./EnableTwoFactorAuth.vue?vue&type=template&id=225b6fcc&scoped=true"
import script from "./EnableTwoFactorAuth.vue?vue&type=script&lang=js"
export * from "./EnableTwoFactorAuth.vue?vue&type=script&lang=js"
import style0 from "./EnableTwoFactorAuth.vue?vue&type=style&index=0&id=225b6fcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225b6fcc",
  null
  
)

export default component.exports